"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { CircleCheck, Truck, FileCheck, Shield, Globe, Package } from "lucide-react";
export default function OperationsPreview() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="operations-preview" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_48%,currentColor_48%,currentColor_52%,transparent_52%)] bg-[length:20px_20px]" />
      </div>

      <div className="relative mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-2 min-h-[600px]">
          {}
          <div ref={leftRef} className="relative flex flex-col justify-center px-8 py-16 lg:px-12 lg:py-20">
            <div className={`transition-all duration-[var(--duration-slow)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              {}
              <div className="flex gap-6 mb-8">
                <div className={`transition-all duration-[var(--duration-slow)] delay-100 ${leftVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
                animation: leftVisible ? "pulse 3s ease-in-out infinite" : "none"
              }}>
                  <CircleCheck className="size-10 text-accent" strokeWidth={1} />
                </div>
                <div className={`transition-all duration-[var(--duration-slow)] delay-200 ${leftVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
                animation: leftVisible ? "pulse 3s ease-in-out 0.5s infinite" : "none"
              }}>
                  <Shield className="size-10 text-accent" strokeWidth={1} />
                </div>
                <div className={`transition-all duration-[var(--duration-slow)] delay-300 ${leftVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
                animation: leftVisible ? "pulse 3s ease-in-out 1s infinite" : "none"
              }}>
                  <FileCheck className="size-10 text-accent" strokeWidth={1} />
                </div>
              </div>

              {}
              <h2 className="font-display text-3xl font-bold mb-4 !text-[hsl(210,11%,15%)] lg:text-4xl">
                Quality Assurance
              </h2>
              <p className="text-lg text-muted-foreground mb-6 leading-relaxed max-w-md">
                Rigorous inspection protocols, lab testing, and comprehensive documentation ensure every commodity meets international standards before shipping.
              </p>

              {}
              <Link to="/OperationsPage#quality" className="group inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all duration-[var(--duration-medium)]">
                <span>Learn More</span>
                <span className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-[var(--duration-medium)]">
                  →
                </span>
              </Link>
            </div>
          </div>

          {}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-accent transform -translate-x-1/2" />

          {}
          <div ref={rightRef} className="relative flex flex-col justify-center px-8 py-16 lg:px-12 lg:py-20 border-t lg:border-t-0 lg:border-l border-accent/20 lg:border-transparent">
            <div className={`transition-all duration-[var(--duration-slow)] ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              {}
              <div className="flex gap-6 mb-8">
                <div className={`transition-all duration-[var(--duration-slow)] delay-100 ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
                animation: rightVisible ? "pulse 3s ease-in-out infinite" : "none"
              }}>
                  <Truck className="size-10 text-accent" strokeWidth={1} />
                </div>
                <div className={`transition-all duration-[var(--duration-slow)] delay-200 ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
                animation: rightVisible ? "pulse 3s ease-in-out 0.5s infinite" : "none"
              }}>
                  <Globe className="size-10 text-accent" strokeWidth={1} />
                </div>
                <div className={`transition-all duration-[var(--duration-slow)] delay-300 ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
                animation: rightVisible ? "pulse 3s ease-in-out 1s infinite" : "none"
              }}>
                  <Package className="size-10 text-accent" strokeWidth={1} />
                </div>
              </div>

              {}
              <h2 className="font-display text-3xl font-bold mb-4 !text-[hsl(210,11%,15%)] lg:text-4xl">
                Logistics Coordination
              </h2>
              <p className="text-lg text-muted-foreground mb-6 leading-relaxed max-w-md">
                End-to-end freight management across sea, air, and land, with flexible Incoterms and on-time delivery to any destination worldwide.
              </p>

              {}
              <Link to="/OperationsPage#logistics" className="group inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all duration-[var(--duration-medium)]">
                <span>Learn More</span>
                <span className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-[var(--duration-medium)]">
                  →
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.05);
          }
        }
      `}</style>
    </section>;
}